import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
  Text,
  ModalProps} from "@chakra-ui/react";
import React, { useEffect } from "react";
import Dropdown from "../components/Dropdown";
import {IKhungGiaDat } from "../_types_";
import { useGlobal } from "../contexts/Globals";
import { showDate1 } from "../utils";

interface IProps extends Omit<ModalProps, "children"> {
  model?: IKhungGiaDat;
  onSave?: (model: IKhungGiaDat) => void;
}

export default function KhungGiaDatDetail({ isOpen, onClose, model, onSave, ...props }: IProps) {
  const { loaiDats, khuVucs } = useGlobal();
  const [giaDat, setGiaDat] = React.useState<IKhungGiaDat>({ id: 0, isDeleted: false, action: 0 });

  useEffect(() => {
    if (!model) {
      setGiaDat({ id: 0, isDeleted: false, action: 0 });
    } else {
      setGiaDat(model);
    }
  }, [model]);

  const handleSaveClick = async () => onSave && onSave(giaDat);

  const handleChangeLoaiDatValue = (v: string | number) => {
    setGiaDat({ ...giaDat, loaiDat: v.toString() });
  }

  const handleChangeKhuVucValue = (v: string | number) => {   
    let item = khuVucs.find(q => q.value === v);
    setGiaDat({ ...giaDat, loaiKhuVucId: Number(v), khuVuc: item?.lable })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Thêm Khung Giá Đất</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack w="full" alignItems="flex-start">
            <Text color="gray.400">Khu vực:</Text>
            <Dropdown
              data={khuVucs}
              selectedVal={giaDat.loaiKhuVucId}
              onChange={(v) =>
                handleChangeKhuVucValue(v)
              }
            />
            <Text color="gray.400">Loại đất:</Text>
            <Dropdown
              data={loaiDats}
              selectedVal={giaDat.loaiDat}
              onChange={(v) =>
                handleChangeLoaiDatValue(v)
              }
            />
            <Text color="gray.400">Vị trí:</Text>
            <Input
              placeholder="Nhập vị trí [1,2,3,4,5]"
              size="md"
              value={giaDat.vitri || ''}
              onChange={(e) => { setGiaDat({ ...giaDat, vitri: e.target.value }) }}
            />
            <Text color="gray.400">Giá tiền:</Text>
            <Input
              placeholder="Nhập giá tiền"
              _placeholder={{ opacity: 1, color: "gray.500" }}
              type='number'
              value={giaDat.giaTien || ''}
              onChange={(e) => { setGiaDat({ ...giaDat, giaTien: e.target.valueAsNumber }) }}
            />
            <Text color="gray.400">Ngày hiệu lực:</Text>
            <Input
              placeholder="Ngày hiệu lực"
              size="md"
              type="date"
              value={showDate1(giaDat.hieuLuc)}
              onChange={(e) => { setGiaDat({ ...giaDat, hieuLuc: e.target.valueAsDate ?? undefined }) }}
              onKeyDown={(e) => {e.preventDefault();}}
            />
            <Text color="gray.400">Ngày hết hiệu lực:</Text>
            <Input
              placeholder="Ngày hết hiệu lực"
              size="md"
              type="date"
              value={showDate1(giaDat.hetHieuLuc)}
              onChange={(e) => { setGiaDat({ ...giaDat, hetHieuLuc: e.target.valueAsDate ?? undefined }) }}
              onKeyDown={(e) => {e.preventDefault();}}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSaveClick}>
            Lưu thông tin
          </Button>
          <Button onClick={onClose}>Bỏ qua</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
